import { Outlet, type RouteObject } from 'react-router-dom';

import {
  ExamCardPreviewProvider,
  ExamEventPreviewProvider,
  ExamPreviewSessionProvider,
  ExamPreviewFormProvider,
  ExamPreviewProvider,
  ServerTimeProvider,
} from '../../providers';

import PreviewCompleted from './completed';
import ExamRoomPreview from './exam-room-preview';
import InstructionPreviewRoute from './instruction';
import { ExamEventPreviewLayout, ExamPreviewLayout, ExamPreviewSettingsLayout } from './layouts';
import { ProtectedExamEventPreviewRoute, ProtectedExamPreviewRoute } from './utils';

const ExamPreviewRoutes: RouteObject[] = [
  {
    element: (
      <ServerTimeProvider enabled={false}>
        <ExamPreviewSettingsLayout>
          <ExamCardPreviewProvider>
            <ExamEventPreviewProvider>
              <ProtectedExamEventPreviewRoute>
                <ExamEventPreviewLayout />
              </ProtectedExamEventPreviewRoute>
            </ExamEventPreviewProvider>
          </ExamCardPreviewProvider>
        </ExamPreviewSettingsLayout>
      </ServerTimeProvider>
    ),
    children: [InstructionPreviewRoute],
  },
  {
    element: (
      <ServerTimeProvider enabled={false}>
        <ExamPreviewSettingsLayout>
          <ExamCardPreviewProvider>
            <ExamEventPreviewProvider>
              <ProtectedExamEventPreviewRoute>
                <Outlet />
              </ProtectedExamEventPreviewRoute>
            </ExamEventPreviewProvider>
          </ExamCardPreviewProvider>
        </ExamPreviewSettingsLayout>
      </ServerTimeProvider>
    ),
    children: [
      {
        element: <ProtectedExamPreviewRoute />,
        children: [
          {
            element: (
              <ExamPreviewProvider>
                <ExamPreviewSessionProvider>
                  <ExamPreviewFormProvider>
                    <ExamPreviewLayout>
                      <Outlet />
                    </ExamPreviewLayout>
                  </ExamPreviewFormProvider>
                </ExamPreviewSessionProvider>
              </ExamPreviewProvider>
            ),
            children: [ExamRoomPreview, PreviewCompleted],
          },
        ],
      },
    ],
  },
];

export default ExamPreviewRoutes;
